import React from 'react';
import { Container } from 'reactstrap';
import {
    DashboardPageHeader,
    ComingSoonCard,
    ModuleLandingGrid,
    ModuleShortcutCard,
} from '../../Components/Common/DashboardKit';

/**
 * Quality module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Swapped video <ComingSoon> for <ComingSoonCard>.
 *  - Added shortcuts to existing routes that fall under "Quality"
 *    in spirit — Digital Inspection (/di), MAFIA Aux (/mafia),
 *    and Contract Review (/contract-review). All three already
 *    exist in allRoutes.js; we're just surfacing them.
 *  - Removed unused imports.
 *
 * Route is wrapped in <RoleProtected requireManager> in allRoutes.js;
 * the shortcut routes have their own protection (the page-level
 * components and module-internal access controls handle that).
 */
const Quality = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-shield-check-line"
                        eyebrow="Quality"
                        title="Quality"
                        subtitle="Inspection, non-conformance, and audits"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Quality" },
                        ]}
                    />

                    <ModuleLandingGrid
                        title="Quality tools"
                        icon="ri-microscope-line"
                        description="Existing inspection and review workflows"
                    >
                        <ModuleShortcutCard
                            icon="ri-microscope-line"
                            label="Digital Inspection"
                            subtitle="Look up jobs, confirm parts, run inspections"
                            tone="info"
                            to="/di"
                        />
                        <ModuleShortcutCard
                            icon="ri-stack-line"
                            label="MAFIA Aux"
                            subtitle="Verify, release, and manage MAFIA tables"
                            tone="primary"
                            to="/mafia"
                        />
                        <ModuleShortcutCard
                            icon="ri-file-text-line"
                            label="Contract Review"
                            subtitle="Author and archive contract review records"
                            tone="success"
                            to="/contract-review"
                        />
                        <ModuleShortcutCard
                            icon="ri-folder-open-line"
                            label="Document Management"
                            subtitle="Browse and search company documents"
                            tone="warning"
                            to="/document-management"
                        />
                    </ModuleLandingGrid>

                    <ComingSoonCard
                        icon="ri-shield-check-line"
                        title="Quality analytics are coming soon"
                        message="Non-conformance trends, audit history, and CAPA tracking will be unified here. Continue using the shortcuts above for inspections and document review."
                        tone="warning"
                        features={[
                            "Non-conformance trend reports",
                            "Audit calendar and history",
                            "CAPA tracking",
                            "Supplier quality scorecards",
                        ]}
                        contact="Reach out to Quality for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Quality;
